import {useMutation} from '@tanstack/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {queryClient} from 'infra/libs/react-query';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {postRespondAddressSuggestion} from '../../services/postRespondAddressSuggestion';

export const usePostRespondAddressSuggestionMutation = () => {
	const beneficiaryCode = useAccountDataStore(state => state.accountData.beneficiary.cdUsuarioC);

	return useMutation({
		mutationKey: [MUTATION_KEYS.RESPOND_ADDRESS_SUGGESTION],
		mutationFn: postRespondAddressSuggestion,
		onSuccess: () => {
			queryClient.setQueryData([QUERY_KEYS.ADDRESS_SUGGESTION, beneficiaryCode], null);
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.ADDRESS_SUGGESTION, beneficiaryCode],
			});
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.ADDRESS_UPDATE_INDICATOR, beneficiaryCode],
			});
		},
	});
};
